module.exports = __webpack_public_path__ + "static/media/icon3.2570d1e4.png";